import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { getGalleryInner } from "../Service/Api";

const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";
const mun_summary = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/pdf/NCS-MUN_Summary.pdf";
const staticYearTabs = ["2025", "2024"];

const MunGallery = ({ items }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeYear, setActiveYear] = useState("");
  const [sidebarActiveYear, setSidebarActiveYear] = useState("2025");
  const [yearTabs, setYearTabs] = useState([]);

  const fallbackItems = [
    { title: "NCS MUN", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Debate Room", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Conference Hall", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Delegate View", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        let galleryItems = Array.isArray(items) ? items : [];

        if (galleryItems.length === 0) {
          const galleryData = await getGalleryInner();
          galleryItems = galleryData.filter((item) => item.category === "NcsMUN");
        }

        const sortedItems = [...galleryItems].sort((a, b) => new Date(b.date) - new Date(a.date));
        const itemsWithDate = sortedItems.filter((item) => item.date);

        if (itemsWithDate.length > 0) {
          const foundYears = Array.from(
            new Set(itemsWithDate.map((item) => String(new Date(item.date).getFullYear())))
          ).sort((a, b) => Number(b) - Number(a));

          setYearTabs(foundYears);
          setActiveYear(foundYears[0] || "");
          setData(itemsWithDate);
        } else {
          setYearTabs([]);
          setActiveYear("");
          setData(sortedItems.length > 0 ? sortedItems : fallbackItems);
        }
      } catch (error) {
        console.error("Error fetching MUN gallery data:", error);
        setYearTabs([]);
        setActiveYear("");
        setData(fallbackItems);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [items]);

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const visibleItems = (() => {
    const sourceItems = loading ? fallbackItems : data;

    if (!yearTabs.length || !activeYear) {
      return sourceItems;
    }

    return sourceItems.filter((item) => String(new Date(item.date).getFullYear()) === activeYear);
  })();

  return (
    <div className="mun-gallery-wrap">
  

     

      <div className="row">
        <div className="col-lg-8 col-md-6 col-sm-12 col-12">
              {yearTabs.length > 0 && (
        <div className="mun-year-tabs" role="tablist" aria-label="MUN gallery years">
          {yearTabs.map((year) => (
            <button
              key={year}
              type="button"
              className={`mun-year-tab${activeYear === year ? " is-active" : ""}`}
              onClick={() => setActiveYear(year)}
            >
              {year}
            </button>
          ))}
        </div>
      )}
          <Slider {...settings}>
            {visibleItems.map((item, index) => (
              <div className="item" key={item._id || item.title || index}>
                <div className="gallery-item">
                  <div className="project-thumb gal-big">
                    <Link to={item._id ? `/ncs-mun-gallery?id=${item._id}` : "/ncs-mun-gallery"}>
                      <LazyLoad>
                        <img
                          src={`${S3_url}/${item.attachments?.[0]}`}
                          alt={item.title || "NCS MUN"}
                          className="img-fluid"
                        />
                      </LazyLoad>
                    </Link>
                  </div>
                  <div className="project-content">
                    <h2 className="title">{item.title}</h2>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="mun-view-all-wrap">
            <Link className="mun-view-all-btn" to="/ncs-mun-gallery" style={{ margin: "auto" }}>
              View All
            </Link>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
          <div className="mun-year-tabs" role="tablist" aria-label="MUN gallery years">
            {staticYearTabs.map((year) => (
              <button
                key={year}
                type="button"
                className={`mun-year-tab${sidebarActiveYear === year ? " is-active" : ""}`}
                onClick={() => setSidebarActiveYear(year)}
              >
                {year}
              </button>
            ))}
          </div>
          {sidebarActiveYear === "2025" && (
            <div className="mun-year-writeup">
              <h3 className="title">21st Jul &amp; 22nd Jul 2025</h3>
              <p className="mun-year-writeup-text">
                Nirmala Convent School successfully hosted its Model United Nations Conference on
                July 21st and 22nd, 2025, offering 210 students a unique platform to engage in
                diplomacy and explore pressing global issues. Delegates represented various
                countries across five dynamic committees, UNGA, UNHRC, UNSC, International Press,
                and the Lok Sabha, participating in rigorous debates, negotiations, and resolution
                drafting.
                The event was graced by Mr. Bharat Patel, Managing Director of Ayoni Foods Pvt Ltd, and Mr. Orm Satani, a dynamic youth icon, who inspired students to become global thinkers and empathetic leaders. Sr. Betty ignited enthusiasm among the participants through her empowering speech Secretary-General Ms. Krisha Sonchhatra officially declared the conference open.
              </p>
            
              <div className="mun-view-all-wrap">
                <Link
                  className="mun-view-all-btn"
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/pdf/NCS-MUN_Summary_2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ margin: "auto" }}
                >
                  Read More
                </Link>
              </div>
            </div>
          )}
          {sidebarActiveYear === "2024" && (
            <div className="mun-year-writeup">
              <h3 className="title">
                30th Sep 24 - 1<sup>st</sup> Oct 24
              </h3>
              <p className="mun-year-writeup-text">
                Nirmala Convent School successfully hosted its inaugural Model United Nations
                Conference on September 30th and October 1st, 2024, bringing together over 150
                students from Classes 8 to 11. Delegates represented various countries across
                five prestigious committees, UNGA, UNHRC, UNEP, and UNODC, engaging in rigorous
                debates, negotiations, and resolution drafting on critical global issues.
                The event was graced by Chief Guest Rev. Fr. Binoy George CMI, who delivered an inspiring keynote on diplomacy and international cooperation. Principal Sr. Betty motivated the participants with her empowering address, while Secretary-General Ms. Misari Gangani officially declared the conference open.
              </p>
              <div className="mun-view-all-wrap">
                <Link
                  className="mun-view-all-btn"
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/pdf/NCS-MUN_Summary_2024.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ margin: "auto" }}
                >
                  Read More
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>

   
    </div>
  );
};

export default MunGallery;
